
// Vue / Vuex
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from 'vuex-class';

// Components
import EventFilter from './EventFilter.vue';
import vSelect from "vue-select";

// Types
import { EventSearchState, EventOperator } from '@/store/event-search/types';
import EventSearchModel from "@/types/eventSearch/EventSearchModel";

// Vuex Modules
const EventSearchStore = namespace("eventSearch");

@Component({
    components: {
        "event-filter": EventFilter,
        "v-select": vSelect,
    }
})
export default class OperatorFilter extends Vue {
    @Prop({ default: null, type: Object, required: true }) value: EventSearchModel;

    @EventSearchStore.Action loadOperators!: () => Promise<void>;

    @EventSearchStore.State((s: EventSearchState) => s.Operators) eventOperators: EventOperator[];

    /**
     * @summary Life cycle hook
     * - loads all operators
     */
    private async mounted(): Promise<void> {
        await this.loadOperators();
    }

    /**
     * @summary Computed property to get the selected event operator by id
     */
	public get operator() {
		return this.eventOperators.find((o) => o.userID === this.value?.operator) ?? null;
	}

    /**
     * @summary Setter to set the operator by id.
     */
	public set operator(value) {
        if (!value) {
            this.value.operator = null;
            return;
        }

        this.value.operator = value.userID;
	}
}
